import { Component, OnDestroy } from '@angular/core';
import { Subject, takeWhile } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';

import { IPanel, PanelsService } from '@app/core/panels';
import { YesNoDialogComponent } from '@app/shared';
import { PanelDialogComponent } from '../panel-dialog/panel-dialog.component';

@Component({
  selector: 'app-panel-list',
  templateUrl: './panel-list.component.html',
  styleUrls: ['./panel-list.component.css']
})
export class PanelListComponent implements OnDestroy {

  public records$: Subject<IPanel[]>;
  public selectedRecords: IPanel[];

  private destroyed: boolean;

  constructor(
    private service: PanelsService,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.records$ = new Subject();
    this.loadRecords();
  }

  private loadRecords(): void {

    this.selectedRecords = [];

    this.service.getList()
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe(records => {
      this.records$.next(records);
    });
  }

  public onRowEdit(panel: IPanel): void {
    this.router.navigate(['/panels', panel.id]);
  }

  public deleteSelected(): void {
    this.dialogService.open(YesNoDialogComponent, {
      height: '300px',
      width: '300px',
      header: 'Eliminar panel/s',
      data: {
        message: '¿Eliminar paneles seleccionados?'
      }
    })
    .onClose
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe(result => {

      if (result) {
        this.service
        .deletePanel(this.selectedRecords.map(r => r.id))
        .pipe(takeWhile(() => !this.destroyed))
        .subscribe(() => {
          this.loadRecords();
        })
      }

    })

  }

  public newPanel(): void {

    this.dialogService.open(PanelDialogComponent, {
      height: '600px',
      width: '800px',
      header: 'Nuevo panel'
    })
    .onClose
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe(panel => {

      if (panel) {
        this.loadRecords();
      }

    })

  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }

}
